import { createStore } from 'vuex'
import nav from './modules/nav.js'
import content from './modules/content.js'
import destination from './modules/destination.js'
import project from './modules/project.js'

// Vuex data store
// Expose a new store instance.
export default createStore({
    modules: {
        nav,
        content,
        destination,
        project
    }
});
